import Actions from '../../odata/actions';

const actions = new Actions('checklistItemTransaction', 'checklistItemTransactions');

export default actions;
